import { useTranslation } from 'react-i18next';

import CardInfo from '../../../../components/card-info/CardInfo';
import { IDataProps } from './data-types';
import { DataStyle } from './data-style';

const Data: React.FC<IDataProps> = ({ values }) => {
  const { t } = useTranslation(['aia']);
  return (
    <DataStyle>
      <CardInfo
        data={[
          { title: t('aia:data.file'), description: [values.numeroExpediente], separator: true },
          { title: t('aia:data.vhc-brand'), description: [values.marca] },
          { title: t('aia:data.vhc-model'), description: [values.modelo] },
          { title: t('aia:data.plate'), description: [values.matricula], separator: true },
          { title: t('aia:data.applicant-name'), description: [values.personaContacto] },
          { title: t('aia:data.policy'), description: [values.numeroPoliza] },
        ]}
      />
    </DataStyle>
  );
};

export default Data;
